import { useState } from "react";
import type { OpenDocument } from "./documents/documentInfo";
import { useOnChatSwitch } from "./useChatSwitchKey";

/**
 * What the person types, picks and opens in one chat: it never follows them into another (MHS-1039). When
 * `chatKey` changes (`useChatSwitchKey`) it starts again from `fresh`, read from the new chat's link: the text
 * handed over to start with and the agent in `?agent=`. Reset while rendering, so the other chat never shows the
 * last one's text, even for a frame.
 */
export function usePerChatState(chatKey: number, fresh: { draft: string; agent: string | null }) {
  const [draft, setDraft] = useState(fresh.draft);
  const [pickedAgent, setPickedAgent] = useState(fresh.agent);
  const [openDoc, setOpenDoc] = useState<OpenDocument | null>(null);
  const [shareOpen, setShareOpen] = useState(false);
  useOnChatSwitch(chatKey, () => {
    setDraft(fresh.draft);
    setPickedAgent(fresh.agent);
    setOpenDoc(null);
    setShareOpen(false);
  });
  return { draft, setDraft, pickedAgent, setPickedAgent, openDoc, setOpenDoc, shareOpen, setShareOpen };
}
